import axios from 'axios';
import {
    apiTransitionNira,
    calculatePersonalDetailsNiraSuccess,
    setShowNiraDetailsModal,
} from '../../../actions/ugMotorInsurance/personalDetails';
import { getAccessToken } from '../../../selectors/ugMotorInsurance/payments';
import { getIsNiraApiPending, getPersonalDetailsForm } from '../../../selectors/ugMotorInsurance/personalDetails';

export const niraCheckService = (store, next, action) => {
    (async () => {
        if (!getIsNiraApiPending(store.getState())) {
            store.dispatch(apiTransitionNira.pending());

            try {
                store.dispatch(calculatePersonalDetailsNiraSuccess(false));
                store.dispatch(setShowNiraDetailsModal(false));
                const resp = await calculate(store.getState());

                const isValid = resp.data.data.matchingStatus === 'true' && resp.data.data.cardStatus === 'Valid';

                store.dispatch(calculatePersonalDetailsNiraSuccess(isValid));
                store.dispatch(apiTransitionNira.success());
                store.dispatch(setShowNiraDetailsModal(true));
            } catch (e) {
                console.error(e);
                if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                    store.dispatch(setExpiredAuth(true));
                }

                store.dispatch(apiTransitionNira.failure());
                store.dispatch(calculatePersonalDetailsNiraSuccess(null));
                store.dispatch(setShowNiraDetailsModal(true));
            }
        }
    })();
    return next(action);
};

const niraCheckServicePayload = (state) => {
    const personalDetails = getPersonalDetailsForm(state);

    const amlWhitelistCalculationPayload = {
        surname: personalDetails.lastName.value || '',
        givenNames: personalDetails.firstName.value || '',
        otherNames: personalDetails.middleName.value || '',
        dateOfBirth: personalDetails.dob.value,
        nationalId: personalDetails.idNumber.value,
        documentId: personalDetails.idCardNumber.value || '',
    };

    return {
        ...amlWhitelistCalculationPayload,
    };
};

const calculate = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ug-motor-insurance/nira-verify';

        return await axios.post(url, niraCheckServicePayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
